import { mapState, mapGetters } from 'vuex';
import ApiService from '@/services/apiService';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'CoreAlarmLogsReportWizard',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    editItem: {
      type: Object,
      required: false,
      default: null
    },
    smartGroupId: {
      type: Number,
      required: false,
      default: null
    },
    accountId: {
      type: Number,
      required: false,
      default: null
    }
  },
  data: function () {
    return {
      formValid: false,
      reportModel: {
        tenantId: null,
        smartGroupId: null,
        meta: {
          title: '',
          description: ''
        },
        filters: {
          originType: 'virtual-device--health-state',
          operationalStatus: null,
          categories: [],
          severities: [],
          condition: null
        },
        timeTrigger: {
          timeZone: 'Europe/Berlin'
        },
        actions: [{
          params: {
            subject: 'Alarmreport {{alarmReportName}} for {{smartGroupName}}',
            locale: 'en-US'
          },
          tables: ['all']
        }]
      },
      step: 1
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'color']),
    ...mapGetters({
      isFeatureFlagEnabled: 'app/isFeatureFlagEnabled'
    })
  },
  watch: {
    editItem: {
      handler: function (val) {
        if (val) {
          this.updateReportModel(val);
        }
      },
      immediate: true
    },
    smartGroupId: {
      handler: function (val) {
        if (val) {
          this.reportModel.smartGroupId = val;
        }
      },
      immediate: true
    },
    accountId: {
      handler: function (val) {
        if (val) {
          this.reportModel.tenantId = val;
        }
      },
      immediate: true
    }
  },
  created() {},
  methods: {
    closeDialog() {
      this.step = 1;
      this.reportModel.tenantId = null;
      this.reportModel.meta.title = '';
      this.$emit('close');
    },
    updateReportModel(e) {
      this.reportModel = cloneDeep(e);
      if (this.smartGroupId) {
        this.reportModel.smartGroupId = this.smartGroupId;
      }
      if (this.accountId) {
        this.reportModel.tenantId = this.accountId;
      }
    },
    submitReport() {
      let promise = !!this.reportModel.id ? ApiService.updateAlarmReport(this, this.reportModel) : ApiService.createAlarmReport(this, this.reportModel);
      promise.then(() => {
        this.$emit('submitted');
        return null;
      }).catch(() => {
        this.$snack(this.$t('AlarmLogs.snacks.reportSubmitFailed'), 'error');
      });
    }
  }
};